import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonButton } from '@ionic/angular/standalone';
import { PaymentItemViewModel } from 'src/app/models/item.model';
import { ShowPaymentEventPayload } from '../../models/event-payloads.model';
import { AttachmentsComponent } from '../attachments/attachments.component';
import { HubItemMessageComponent } from '../hub-item-message/hub-item-message.component';
import { ListItemHeaderComponent } from '../list-item-header/list-item-header.component';
import { PaymentPublisherComponent } from '../payment-publisher/payment-publisher.component';

@Component({
  selector: 'app-payment-item',
  templateUrl: './payment-item.component.html',
  styleUrls: ['./payment-item.component.scss'],
  imports: [
    ListItemHeaderComponent,
    HubItemMessageComponent,
    AttachmentsComponent,
    PaymentPublisherComponent,
    IonButton
  ]
})
export class PaymentItemComponent {
  @Input() item: PaymentItemViewModel;
  @Input() showPublisherLink: boolean;
  @Output() selectItem = new EventEmitter<string>();
  @Output() selectStudent = new EventEmitter<number>();
  @Output() selectPaymentRequests = new EventEmitter();
  @Output() openAttachment = new EventEmitter<string>();
  @Output() getThumb = new EventEmitter<string>();
  @Output() showPayment = new EventEmitter<ShowPaymentEventPayload>();

  showPaymentFunction(event): void {
    event.stopPropagation();
    this.showPayment.emit({
      studentId: this.item.student.id,
      schoolId: this.item.schoolId,
      paymentId: this.item.categoryId
    });
  }
}
